import Data from "../types/Data";

export default function hasReceipts(data: Data) {
  return data.receiptIds.length > 0;
}
